import { DISPATCH_SEARCH, CLEAN_SEARCH } from './searchTypes';

const initialState = {
  searchValue: null,
};

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISPATCH_SEARCH:
      return {
        ...state,
        searchValue: action.payload,
      };
    case CLEAN_SEARCH:
      return {
        ...state,
        searchValue: null,
      };

    default:
      return { ...state };
  }
};

export default SearchReducer;
